var _defs, _rect, _rect2, _path, _circle, _circle2, _circle3, _circle4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCompartments(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 800 800",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #3b66b0;\r\n        stroke-width: 0px;\r\n      }\r\n    "))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 6.7,
    y: 545.3,
    width: 190.6,
    height: 18.4
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 602.6,
    y: 545.3,
    width: 190.6,
    height: 18.4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M787.4,197.5H16.5v332.6h186.5l59.6,52.6h282.8l55.2-52.3h184.3v-.3h2.4V197.5ZM406.8,511.9v-154.4h362.2v154.1h-175.3l-.3.3h-186.6ZM769,339.1h-362.2v-123.1h362.2v123.1ZM388.3,215.9v123.1H35v-123.1h353.4ZM215.2,516.2l-5.2-4.6H35v-154.1h353.4v206.7h-118.7l-54.4-48ZM538.1,564.2h-131.4v-33.8h167.1l-35.8,33.8Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 61.7,
    cy: 617,
    r: 40.9
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 159.8,
    cy: 617,
    r: 40.9
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 629.4,
    cy: 617,
    r: 40.9
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 727.5,
    cy: 617,
    r: 40.9
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompartments);
export default __webpack_public_path__ + "static/media/compartments.29ef7a6ec9354516597095d79c0814fd.svg";
export { ForwardRef as ReactComponent };